var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubspot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 8.2V5.7a2 2 0 0 0 1.15-1.8A2.02 2.02 0 0 0 16.63 2a2.02 2.02 0 0 0-2.02 1.9c0 .77.44 1.43 1.08 1.77v2.56a5.15 5.15 0 0 0-2.47 1.26l-6.54-5.1a2.46 2.46 0 0 0 .07-.54A2.36 2.36 0 0 0 4.4 1.5 2.36 2.36 0 0 0 2.05 3.85 2.36 2.36 0 0 0 4.4 6.2c.48 0 .92-.15 1.3-.4l6.42 5a5.2 5.2 0 0 0-.78 2.72 5.2 5.2 0 0 0 .9 2.92l-2.02 2.02a2.14 2.14 0 0 0-.62-.1 2.15 2.15 0 1 0 2.15 2.15c0-.22-.04-.43-.1-.62l1.98-1.98a5.19 5.19 0 1 0 3.87-9.71z",
    fill: "#FF7A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspot);
export default __webpack_public_path__ + "static/media/hubspot.7349ffd88db6b3be0c52e50ef6084ed6.svg";
export { ForwardRef as ReactComponent };